<template>
    <div style="background-color: #f5f5f5;">
        <!-- 图片 -->
        <div class="bg">
            <div class="sub-title">Products</div>
            <!-- <div class="title">产品中心</div> -->
        </div>
        <div class="m-3">
            <div>
                <div class="text-left title">{{ info.fJ_ProductInfo!=null?info.fJ_ProductInfo.productNameEN:"" }}</div>
                <!-- <div class="text-left" style="margin-top: 10px;">{{info.fJ_ProductInfo!=null?info.fJ_ProductInfo.productNameEN:""  }}</div> -->
            </div>
            <div class="mt-3">
                <!--  <img src="../../assets/img/banner-02.jpg" style="width: 100%;" alt="">-->
                <div class="bgg">
                    <img :ref="prefix+info.fJ_ProductInfo.id" :src="http.ipAddress+info.fJ_ProductInfo.filePath"
                                style="width: 100%;" alt="" >
                </div>
                <p style="margin-top: 10px; text-indent: 2rem;line-height: 30px;">
                    {{info.fJ_ProductInfo_Description.remark}}
                </p>
                <div>
                    <div class="border">
                        <div>
                            <div class="ttitle1">Application</div>
                            <!-- <div class="" style="margin-top: 10px;">Application</div> -->
                        </div>
                        <p class="pp" style="margin-top: 10px; text-indent: 2rem;line-height: 30px;">
                            {{info.fJ_ProductInfo_Description.application}}
                        </p>
                    </div>
                    <!-- <div class="border">
                        <div>
                            <div class="ttitle1">特点</div>
                            <div class="" style="margin-top: 10px;">Features</div>
                        </div>
                        <p class="pp" style="white-space: pre-line; text-indent: 2rem;line-height: 30px;">
                            {{info.features}}
                        </p>
                        <div class="flex-row" style="margin-top: 20px;">
                             <div class="ttitle1" style="width: 150px;">高性能</div> 
                            <div>
                                <p class="pp">
                                    采用高效的控制算法，负载自适应能力强，转矩响应快。
                                </p>
                                <p class="pp" style="margin-top: 10px;">
                                    采用先进的PWM技术，实现电池电压高效利用。
                                </p>
                                <p class="pp" style="margin-top: 10px;">
                                    宽范围速度调节，加减速平滑控制，带来舒适的操作体验。
                                </p>
                            </div>
                        </div> 
                        <div class="flex-row" style="margin-top: 20px;">
                          <div class="ttitle1" style="width: 150px;">高可靠性</div> 
                            <div>
                                <p class="pp">
                                    采用高可靠性的低压大功率MOSFET器件
                                </p>
                                <p class="pp" style="margin-top: 10px;">
                                    功率电路采用高导热系数铝基板散热
                                </p>
                                <p class="pp" style="margin-top: 10px;">
                                    完善的告警保护功能
                                </p>
                            </div>
                        </div> 
                         <div class="flex-row" style="margin-top: 20px;">
                         <div class="ttitle1" style="width: 150px;">高可适配性</div> 
                            <div>
                                <p class="pp">
                                    提供丰富的外部接口：多路数字和模拟输入，多路高动率和低功率输出
                                </p>
                                <p class="pp" style="margin-top: 10px;">
                                    可通过FJ上位机软件、蓝牙对控制器参数进行现场监控
                                </p>
                                <p class="pp" style="margin-top: 10px;">
                                    可通过FJ仪表对控制器参数进行现场或远程监控
                                </p>
                                <p class="pp" style="margin-top: 10px;">
                                    内置电子接触器，性能稳定且减少体积
                                </p>
                            </div>
                        </div> 
                    </div> -->
                    <div class="border" v-if="info.fJ_ProductInfo.productType == 1">
                        <div>
                            <div class="ttitle1">Specifications</div>
                            <!-- <div class="" style="margin-top: 10px;">Specifications</div> -->
                        </div>

                        <table style="color:gray;" border="0" cellpadding="0" cellspacing="0" v-for="fJ_ProductControlSpec in info.fJ_ProductControlSpecs" :key="fJ_ProductControlSpec.id">
                            <tr><td style="width: 49%;font-weight: bold;">Battery voltage range</td><td style="width: 51%;">{{ fJ_ProductControlSpec.voltageRange }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Maximum operating current</td><td style="width: 51%;">{{ fJ_ProductControlSpec.maxWorkCurrent }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Working environment temperature</td><td style="width: 51%;">{{ fJ_ProductControlSpec.maxWorkTemperature }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Storage temperature</td><td style="width: 51%;">{{ fJ_ProductControlSpec.storageTemperature }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Working protection temperature</td><td style="width: 51%;">{{ fJ_ProductControlSpec.workProtectTemperature }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Working humidity</td><td style="width: 51%;">{{ fJ_ProductControlSpec.workingHumidity }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Protection level</td><td style="width: 51%;">{{ fJ_ProductControlSpec.protectionGrade }}</td></tr>
                        </table>

                        <!-- <div  v-for="fJ_ProductControlSpec in info.fJ_ProductControlSpecs" :key="fJ_ProductControlSpec.id">
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Battery voltage range</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlSpec.voltageRange }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Maximum operating current</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlSpec.maxWorkCurrent }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Working environment temperature</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlSpec.maxWorkTemperature }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Storage temperature</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlSpec.storageTemperature }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Working protection temperature</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlSpec.workProtectTemperature }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Working humidity</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlSpec.workingHumidity }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Protection level</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlSpec.protectionGrade }}</div>
                            </div>
                        </div> -->
                    </div>
                    <!--控制器选型表-->
                    <div class="border"  v-if="info.fJ_ProductInfo.productType == 1">
                        <div>
                            <div class="ttitle1">Option selection</div>
                        </div> 
                            <div  v-for="fJ_ProductControlType in info.fJ_ProductControlTypes" :key="fJ_ProductControlType.id">
                            <div>
                            <div class="ttitle1">{{ fJ_ProductControlType.model }}</div>
                            </div>

                            <table style="color:gray;">
                            <tr><td style="width: 49%;font-weight: bold;">Battery voltage (V)</td><td style="width: 51%;">{{ fJ_ProductControlType.voltage }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">1-minute rated current (RMS A)</td><td style="width: 51%;">{{ fJ_ProductControlType.current1 }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">S1-2 minute rated current (RMS A)</td><td style="width: 51%;">{{ fJ_ProductControlType.s1Current2 }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">S2-60 minute rated current (RMS A)</td><td style="width: 51%;">{{ fJ_ProductControlType.s2Current60 }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">S3-10 second peak curret (RMS A)</td><td style="width: 51%;">{{ fJ_ProductControlType.s3PeakValue }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Structure size</td><td style="width: 51%;">{{ fJ_ProductControlType.size }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Contactor</td><td style="width: 51%;">{{ fJ_ProductControlType.contactor }}</td></tr>
                            </table>

                            <!-- <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Battery voltage (V)</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlType.voltage }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">1-minute rated current (RMS A)</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlType.current1 }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">S1-2 minute rated current (RMS A)</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal" v-text="fJ_ProductControlType.s1Current2"></div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">S2-60 minute rated current (RMS A)</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlType.s2Current60 }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">S3-10 second peak curret (RMS A)</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlType.s3PeakValue }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Structure size</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlType.size }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Contactor</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductControlType.contactor }}</div>
                            </div> -->
                            </div>
                            <div class="pp1">{{info.fJ_ProductInfo_Description.ettribute1}}</div>
                    </div>
                    
                    <!--仪表规格表-->
                    <div class="border" v-if="info.fJ_ProductInfo.productType!= 1">
                        <div>
                            <div class="ttitle1">Specifications</div>
                            <!-- <div class="" style="margin-top: 10px;">Specifications</div> -->
                        </div>

                        
                        <table style="color:gray;" v-for="fJ_ProductMeterSpec in info.fJ_ProductMeterSpecs" :key="fJ_ProductMeterSpec.id">
                            <tr><td style="width: 49%;font-weight: bold;">Operating voltage range</td><td style="width: 51%;">{{ fJ_ProductMeterSpec.workVoltage }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Rated working voltage</td><td style="width: 51%;">{{ fJ_ProductMeterSpec.ratedVoltage }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Rated working current</td><td style="width: 51%;">{{ fJ_ProductMeterSpec.ratedCurrent }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Working temperature</td><td style="width: 51%;">{{ fJ_ProductMeterSpec.workTemperature }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Storage temperature</td><td style="width: 51%;">{{ fJ_ProductMeterSpec.storageTemperature }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Working humidity</td><td style="width: 51%;">{{ fJ_ProductMeterSpec.workingHumidity }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Protection level</td><td style="width: 51%;">{{ fJ_ProductMeterSpec.protectionGrade }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">RF communication</td><td style="width: 51%;">{{ fJ_ProductMeterSpec.rfCommunication }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Liquid crystal display</td><td style="width: 51%;">{{ fJ_ProductMeterSpec.lcdScreen }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Communication mode</td><td style="width: 51%;">{{ fJ_ProductMeterSpec.communicateType }}</td></tr>
                        </table>

                        <!-- <div  v-for="fJ_ProductMeterSpec in info.fJ_ProductMeterSpecs" :key="fJ_ProductMeterSpec.id">
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Operating voltage range</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductMeterSpec.workVoltage }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Rated working voltage</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductMeterSpec.ratedVoltage }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Rated working current</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductMeterSpec.ratedCurrent }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Working temperature</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductMeterSpec.workTemperature }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Storage temperature</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductMeterSpec.storageTemperature }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Working humidity</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductMeterSpec.workingHumidity }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Protection level</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductMeterSpec.protectionGrade }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">RF communication</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductMeterSpec.rfCommunication }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Liquid crystal display</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductMeterSpec.lcdScreen }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Communication mode</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductMeterSpec.communicateType }}</div>
                            </div>
                        </div> -->
                    </div>
                    <!--仪表选型表-->
                    <div class="border" v-if="info.fJ_ProductInfo.productType != 1">
                        <div>
                            <div class="ttitle1">Option selection</div>
                            <!-- <div class="" style="margin-top: 10px;">Type</div> -->
                        </div>

                        <div  v-for="fJ_ProductMeterType in info.fJ_ProductMeterTypes" :key="fJ_ProductMeterType.id">
                            <div>
                            <div class="ttitle1">{{ fJ_ProductMeterType.model }}</div>
                            </div>
                            <table style="color:gray;">
                            <tr><td style="width: 49%;font-weight: bold;">Number</td><td style="width: 51%;">{{ fJ_ProductMeterType.productNum }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Rated voltage</td><td style="width: 51%;">{{ fJ_ProductMeterType.ratedVoltage }}</td></tr>
                            <tr><td style="width: 49%;font-weight: bold;">Whether the remote monitoring function is supported</td><td style="width: 51%;">{{ fJ_ProductMeterType.remoteMonitorDesc }}</td></tr>
                            </table>
                            <!-- <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Number</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductMeterType.productNum }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Rated voltage</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal">{{ fJ_ProductMeterType.ratedVoltage }}</div>
                            </div>
                            <div style="width: 100%;float:left;  display: flex;vertical-align: middle;">
                                <div style="width: 49%;float:left;border:1px solid;font-size: 13px;white-space: normal;font-weight: bold;">Whether the remote monitoring function is supported</div>
                                <div style="width: 51%;float:left;border:1px solid;font-size: 13px;white-space: normal" v-text="fJ_ProductMeterType.remoteMonitorDesc"></div>
                            </div> -->
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { controllerData, meterData } from "../products/products";
export default {
    data() {
        return {
            prefix:"product",
            switch:1,
            info:{}
            // testText: " FJ-G1系列产品为交流感应电机控制器，采用先进的控制算法，有效提高电动车辆的可操作性和舒适性并可借助FJ运程监控系统(选搭配FJ-M1仪表)，实现电动车辆的远程管理、报警预警、参数查询与修改、运行数据分析等车联网功能，同时配备蓝牙、4G功能要加便于调试及远程控制。",
            // tableData: [{
            //     name1: '32-60V ',
            //     name2: '400A ',
            //     name3: '-40C-50℃  ',
            //     name4: '-40C-85℃',
            //     name5: '85℃',
            //     name6: '<85%',
            //     name7: 'IP67',
            // }, {
            //     name1: '32-60V ',
            //     name2: '400A ',
            //     name3: '-40C-50℃  ',
            //     name4: '-40C-85℃',
            //     name5: '85℃',
            //     name6: '<85%',
            //     name7: 'IP67',
            // }],
            // tableData1: [{
            //     name1: 'FJ-D1-24-S  ',
            //     name2: '24',
            //     name3: '250/300/350',
            //     name4: '125/150/175',
            //     name5: 'S',
            // }, {
            //     name1: 'FJ-D1-24-S  ',
            //     name2: '24',
            //     name3: '250/300/350',
            //     name4: '125/150/175',
            //     name5: 'S',
            // }],
            // switch: 1,
            // info: {}
        }
    },
    methods: {

    },
    mounted() {
        debugger
        console.log('indexindexindex', this.$route.query.switch);
        if(this.$route.query.switch) this.switch =  this.$route.query.switch
        let index =  this.$route.query.index;
        // if(this.switch == 1) {
        //     console.log(controllerData[index]);
        //     this.info = controllerData[index]
        // }else {
        //     console.log(meterData[index]);
        //     this.info = meterData[index]
        // }
        let vType= this.$route.query.type;
        if(vType!=null&&vType=="app"){
             this.$emit("hideHead");
        }
        let that=this;
        this.http.post("/api/FJ_ProductInfo/GetProductInfoDetail",JSON.stringify({productid:parseInt(index,10),lanuage:1})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
            debugger
            that.info=objResult.data;
            
            console.log("info:"+JSON.stringify(that.info))
               // that.refs.product10.focus();
               // document.getElementById("product10").focus();

            }
        });

    }
}
</script>

<style scoped>
.bg {
    background: url('../../assets/img/productbanner.jpg') no-repeat;
    background-size: 100% ;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.m-3 {
    margin: 30px;
}

.video {
    background-color: #00585252;
    height: 200px;
    width: 100%;
}

.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}

.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}

.mt-1 {
    margin-top: 10px;
}

.mt-3 {
    margin-top: 30px;
}

.border {
    margin-top: 30px;
    /* padding-top: 30px; */
    border-top: 1px solid #eee;
}

.ttitle1 {
    font-size: 16px;
    font-weight: 700;
    line-height: 30px;
}

.pp {
    font-size: 16px;
}

table {
    border: 1px solid;
    border-collapse: collapse;
    width:100%;
    font-size: 12px;
    margin-top: 10px;
}
td {
    border: 1px solid;
    border-collapse: collapse;
}


</style>


// WEBPACK FOOTER //
// src/views/products/M_detail.vue